import React from "react";
import { Wrapper, Image } from "./styled";
import Icon from "../../../../images/options.svg";

const OptionsIcon = () => {
  return (
    <Wrapper>
      <Image src={Icon} alt="icon" />
    </Wrapper>
  );
};

export default OptionsIcon;
